import { objectEntriesTyped } from '@bos/utils';

import type { BankDocumentTemplateV5 } from '../../../../../../api/generated/cz.partners.bank.backofficegateway.documents';
import type { AppSelectOption } from '../../../../../../components/AppSelectComboboxField';
import { useBankDocumentTypeTranslationMap } from '../../../../../../components/documents/hooks/useBankDocumentTypeTranslationMap';
import { filterOptionsByAvailableValues } from '../../../../../../helpers/filterOptionsByAvailableValues';

export const useBankDocumentCategorySelectOptions = (
	availableTemplates: BankDocumentTemplateV5[] | undefined,
) => {
	const categoryTranslationMap = useBankDocumentTypeTranslationMap();

	const allOptions: AppSelectOption[] = objectEntriesTyped(
		categoryTranslationMap,
	)
		.map(([value, translation]) => ({
			value,
			text: translation,
		}))
		.sort((a, b) => a.text.localeCompare(b.text));

	const options = filterOptionsByAvailableValues(
		allOptions,
		availableTemplates,
	);

	return options;
};
